import {
    Point, Intersect, Geometry, Rect, Size, RectAlign, Matrix, MatrixVector, normalVariable,
    randomId, Dictionary, HashTable, Queue, Set, Node, Link, Graph, PathDefiner
} from "@progress/kendo-diagram-common";

(function() {
    // Imports ================================================================
    var kendo = window.kendo,
        diagram = kendo.dataviz.diagram;

    kendo.deepExtend(diagram, {
        init: function(element) {
            kendo.init(element, diagram.ui);
        },

        Point: Point,
        Intersect: Intersect,
        Geometry: Geometry,
        Rect: Rect,
        Size: Size,
        RectAlign: RectAlign,
        Matrix: Matrix,
        MatrixVector: MatrixVector,
        normalVariable: normalVariable,
        randomId: randomId,
        Dictionary: Dictionary,
        HashTable: HashTable,
        Queue: Queue,
        Set: Set,
        Node: Node,
        Link: Link,
        Graph: Graph,
        PathDefiner: PathDefiner
    });
})();
